<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Import City</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/csv_files/city.csv">
                    <v-btn color="white" rounded outlined class="ma-2 downbtn">
                        Download CSV format
                        <v-icon right dark>mdi-cloud-download</v-icon>
                    </v-btn>
                </a>
            </v-toolbar>

            <v-row dense justify="center">
                <v-col sm="4">
                    <v-file-input placeholder="CSV of City" prepend-icon="mdi-file" label="Import City" rounded dense
                        flat outlined show-size v-model="file"></v-file-input>
                </v-col>
                <v-col sm="2">
                    <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="load1 == true">

            <span v-if="success_list.length > 0">
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>Successful Records</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>

                </v-toolbar>
                <br />
                <v-data-table :headers="headers" :items="success_list" sort-by class="elevation-1 mytable" dense
                    :search="search" :loading="output_load"></v-data-table>
            </span>
            <span v-if="statuslist.length > 0">
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>Failed Records</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>

                </v-toolbar>
                <br />
                <v-data-table :headers="headers" :items="statuslist" sort-by class="elevation-1 mytable" dense
                    :search="search" :loading="output_load"></v-data-table>
            </span>
        </v-card>
        <div id="my-table-id">
            <v-data-table :headers="headers1" :items="city_list" class="elevation-1 mytable" :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>City</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-row dense>
                        <v-col cols="12" sm="3" md="3">

                            <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'City')"
                                :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                        </v-col>
                        <v-col sm="6" md="4" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn color="mb-2 button" v-on="on">Add City</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.city" persistent-hint :hint="editedIndex == -1
                                                        ? 'For example :: Nashik,pune'
                                                        : 'For example ::  Nashik,pune'
                                                        " label="Name" :rules="[(v) => !!v || 'required']" rounded
                                                        outlined dense>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete dense v-model="editedItem.state_id"
                                                        :items="states_list" label="State" item-text="name"
                                                        item-value="id" single-line rounded outlined
                                                        :rules="[(v) => !!v || 'required']"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-checkbox v-model="editedItem.isActive" color="success"
                                                        label="Is Active?"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn color="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>







                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
            </v-data-table>
        </div>




    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data() {
        return {
            show_scuuess_table: false,
            success_list: [],
            file: null,
            search: "",
            id: "",
            snackbar: false,
            overlay: false,
            snackbar_msg: "",
            isActive: true,
            color: "",

            valid: false,
            statuslist:[],
            editedIndex: -1,
            load1: false,
            load: false,
            dialog: false,
            loading3: false,
            states_list: null,
            // extraBreadcrumbItems: [
            //     { text: "City Master", disabled: true, href: "" },

            // ],


            // breadcrumbClass: "breadcrumb-style1",
            city_list: [],
            state: null,
            errorMsg: {
                fvd: false,
            },
            editedItem: {
                state_id: "",
                id: "",
                state_name: "",
                city: "",
                isActive: true,
            },

            defaultItem: {
                state_id: "",
                id: "",
                state_name: "",
                city: "",
                isActive: true,
            },
            headers: [
                { text: "Sr.NO", value: "serial_number" },
                { text: "City ", value: "city" },
                { text: "Status", value: "reason" },
            ],
            headers1: [
                { text: "city Name", value: "city" },
                { text: "State Name", value: "state_name" },
                { text: "Active", value: "isactive" },
                { text: "Action", value: "action" },
            ],
            output_load: false,
        };
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New City" : "Edit City";
        },
    },
    methods: {

        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
    <tr>
      <th>City Name</th>
      <th>State Name</th>
      
      
    </tr>`;

            this.city_list.forEach((item, index) => {
                tab_text += `
    <tr>
        <td>${item.city || ''}</td> 
        <td>${item.state_name || ''}</td> 
        
    </tr>`;
            });

            tab_text += '</table>';

            const blob = new Blob([tab_text], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        submitFile() {
            if (this.file == null) {
                alert("Please select the file!");
            } else {
                this.output_load = true;
                let formData = new FormData();
                formData.append("file", this.file);
                axios
                    .post("admission/importcity", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            if (res.data.statuslist[0].failedlist.length > 0) {
                                this.statuslist = res.data.statuslist[0].failedlist;
                                this.load1 = true;

                            }
                            if (res.data.statuslist[0].statuslist.length > 0) {
                                this.success_list = res.data.statuslist[0].statuslist;
                                this.load1 = true; 
                            }
                            this.onLoad();
                        }
                    })
                    .catch(function () {
                        console.log("FAILURE!!");
                    })
                    .finally(() => {
                        this.output_load = false;
                    });
            }


        },
        initializeErrorMsgFalse() {
            this.errorMsg.fvd = false;
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/admission/getcityListall")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((this.load = true)) {
                            this.overlay = false;
                            this.city_list = res.data.city_list;
                            this.states_list = res.data.states_list;
                            //window.alert(JSON.stringify(this.month_list))
                        }
                    } else {
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    var overlay = false;
                });
        },

        editItem(item) {
            this.editedIndex = this.city_list.indexOf(item);
            this.dialog = true;
            this.editedItem.id = item.id,
                this.editedItem.city = item.city;
            this.editedItem.isActive = item.isactive,
                this.editedItem.state_id = item.state_id;
            this.editedItem.state_name = item.state_name;
        },
        save() {
            //window.alert(this.editedIndex)
            if (this.editedIndex > -1) {

                if (this.isValidated()) {

                    axios
                        .post("/admission/editCity", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "200") {
                                this.showSnackbar(
                                    "#4caf50",
                                    "City Updated Successfully..."
                                ); // show snackbar on success
                                this.onLoad();
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "City Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {
                //window.alert(JSON.stringify(this.editedItem))
                axios
                    .post("/admission/saveCity", this.editedItem)
                    .then((res) => {
                        if (res.data.status.code == "200") {
                            this.showSnackbar(
                                "#4caf50",
                                "City Added Successfully..."
                            ); // show snackbar on success
                            this.onLoad();
                        } else if (res.data.status.code == "NA") {
                            this.showSnackbar("#b71c1c", "City Already Present!!!"); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            }
        }, // end of save()
        isValidated() {
            if (this.editedItem.id) {
                return true;
            } else {
                if (!this.editedItem.id) {
                    this.errorMsg.fvd = true;
                }

                return false;
            }
        }, // .....end of isValidated()

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },


        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

    },
    mounted() {
        this.onLoad();
    }
};
</script>

<style scoped>
.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
    font-size: 80%;
}

.downbtn {
    float: right;
}

.even {
    background-color: whitesmoke;
}

.odd {
    background-color: white;
}

.mytable /deep/ thead th {
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.downbtn {
    float: right;
}

.mytable2 /deep/ thead th {
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

/* new css */
table,
th {
    padding: 10px;
    border: 1px solid black;
    border-collapse: collapse;
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.mandatory {
    color: red;
}
</style>
